const m = require('air-vue-model')()
m.url = 'ingredient_images'
m.name = 'ingredientImage'

module.exports = m